import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Header from './components/Header';
import Footer from './components/Footer';
import Footer2 from './components/Footer2';
import RightSidebar from './components/RightSidebar';
import Step1 from './steps/Step1';
import Step2 from './steps/Step2';
import Step3 from './steps/Step3';
import Step4 from './steps/Step4';
import Step5 from './steps/Step5';
import Step6 from './steps/Step6';
import Step7 from './steps/Step7';
import { startAction, backAction, checkinAction, loadingAction } from '../../../saga/actions/workflow';
import { getBackUrl, getCheckinUrl } from './url';

import IMG_BACK from '../../../assets/images/undo_button.svg';
import Loading from '../../../components/Loading';

function BorrowStep(props) {
  const [step, setStep] = useState(0);
  const [data, setData] = useState({});
  const { search } = useLocation();
  const history = useHistory();
  const offerCode = new URLSearchParams(search).get('offerCode');
  const key = new URLSearchParams(search).get('key');
  const workflowData = props.workflow?.data;

  useEffect(() => {
    if (!key) {
      const isInProgress = localStorage.getItem('isInProgress') || null;
      const savedOfferCode = localStorage.getItem('offerCode');
      if (isInProgress && isInProgress !== 'undefined' && savedOfferCode === offerCode) {
        props.checkinAction({
          url: getCheckinUrl(),
          method: 'PUT',
          data: {},
          success: (response) => {
            console.log('checkin', response);
            localStorage.setItem('key', response.key);
          },
          fail: () => {
          },
        });
      } else {
        props.startAction({
          url: '/workflows/direct-mail/dtc-mailer/start',
          method: 'POST',
          data: {
            offerCode: offerCode || null,
          },
          success: (response) => {
            localStorage.setItem('key', response.key);
            localStorage.removeItem('isInProgress');
          },
          fail: () => {
          },
        });
      }
    } else if (!workflowData || (workflowData && typeof workflowData === 'object' && Object.keys(workflowData).length === 0)) {
      props.checkinAction({
        url: getCheckinUrl(key),
        method: 'PUT',
        data: {},
        success: (response) => {
          console.log('checkin with key', response);
          localStorage.setItem('key', response.key);
        },
        fail: () => {
        },
      });
    }
  }, [props.startAction, props.checkinAction, offerCode, key]); // component didmount

  useEffect(() => {
    if (workflowData) {
      let redirectUrl;
      const { url } = workflowData;
      if (url !== 'dtc-mailer/loan-amount') { // if it's not a first screen
        localStorage.setItem('isInProgress', url);
        localStorage.setItem('offerCode', offerCode);
      } else {
        localStorage.removeItem('isInProgress');
      }
      switch (url) {
        case 'dtc-mailer/continue':
          history.push(`/dtc-mailer/continue?key=${key}`);
          break;
        case 'dtc-mailer/loan-amount': setStep(1); setData(workflowData.data); break;
        case 'dtc-mailer/contact': setStep(2); setData(workflowData.data); break;
        case 'dtc-mailer/name': setStep(3); setData(workflowData.data); break;
        case 'dtc-mailer/address': setStep(4); setData(workflowData.data); break;
        case 'dtc-mailer/personal-information': setStep(5); setData(workflowData.data); break;
        case 'dtc-mailer/employment': setStep(6); setData(workflowData.data); break;
        case 'dtc-mailer/submit': setStep(7); setData(workflowData.data); break;
        case 'dtc-mailer/submitted':
          redirectUrl = _.get(workflowData, 'data.dtcUrl') || '';
          if (redirectUrl) {
            props.loadingAction();
            window.location.href = redirectUrl;
          }
          break;
        default:
          break;
      }
    }
  }, [props.loadingAction, workflowData, offerCode]);
  // console.log('state', step, data, props.workflow);

  const handleGoBack = () => {
    props.backAction({
      url: getBackUrl(),
      method: 'PUT',
      data: {},
    });
  };

  const handleClickHere = () => {
    window.location.href = '/main';
  };

  let stepContainer = null;
  switch (step) {
    case 1:
      stepContainer = <Step1 data={data} />;
      break;
    case 2:
      stepContainer = <Step2 data={data} />;
      break;
    case 3:
      stepContainer = <Step3 data={data} />;
      break;
    case 4:
      stepContainer = <Step4 data={data} />;
      break;
    case 5:
      stepContainer = <Step5 data={data} />;
      break;
    case 6:
      stepContainer = <Step6 data={data} />;
      break;
    case 7:
      stepContainer = <Step7 data={data} />;
      break;
    default:
      break;
  }

  return (
    <div className="pl-0 pr-0 md:pl-32 md:pr-32">
      {!props.workflow.isLoading && step !== 0 && <Header step={step} />}
      <div className="m-auto w-10/12 md:w-2/3">
        {step > 1 && !props.workflow.isLoading
          && (
          <div className="flex items-center mt-6 md:mt-20 text-[#000A2F] cursor-pointer">
            <img src={IMG_BACK} alt="back_button" className="mr-2" />
            <div className="font-bold text-sm" onClick={handleGoBack}>GO BACK</div>
          </div>
          )}
        {props.workflow.isLoading && <Loading />}
        {!props.workflow.isLoading && step !== 0
          && (
          <div className="w-full flex mt-11 md:mt-16 justify-between mb-[50px]">
            <div className="w-full border-0 lg:w-[calc(100%-200px)] lg:border-r lg:border-r-[#E7E7E7]">
              {step === 1
                && (
                <div className="mb-[30px]">
                  <div className="font-bold text-[40px] leading-[46px] text-[#263952]">
                    Hello
                    {' '}
                    {data.firstName}
                    {' '}
                  </div>
                  {(offerCode && data.firstName)
                    && (
                    <div className="text-[#9B9B9B] text-[12px]">
                      Not
                      {' '}
                      {data.firstName}
                      ?
                      {' '}
                      <span className="underline text-[#3988E2] cursor-pointer" onClick={handleClickHere}>click here</span>
                    </div>
                    )}
                </div>
                )}
              <div className="text-[#3988E2] text-sm font-bold text-center md:text-left mb-2">
                Step
                {' '}
                {step}
                {' '}
                of 7
              </div>
              {stepContainer}
              <Footer />
            </div>
            <div className="hidden lg:block">
              <RightSidebar />
            </div>
          </div>
          )}
        {!props.workflow.isLoading && step !== 0 && <Footer2 />}
      </div>
    </div>
  );
}

BorrowStep.propTypes = {
  workflow: PropTypes.object.isRequired,
  startAction: PropTypes.func.isRequired,
  backAction: PropTypes.func.isRequired,
  checkinAction: PropTypes.func.isRequired,
  loadingAction: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => ({
      workflow: state.workflow,
    }),
    {
      startAction,
      backAction,
      checkinAction,
      loadingAction,
    }
  )
)(BorrowStep);
